import React, { useEffect, useState } from 'react';
import Switch from 'react-switch';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Row, Col, Button } from 'reactstrap';
import { ArrayItem } from './constants';
import './configPOD.scss';

interface TableConfigFieldsProps {
    ArrayFields: Array<ArrayItem>;
    handleInputChange: (updatedArrayBody: Array<ArrayItem>) => void;
}

const TableConfigFields: React.FC<TableConfigFieldsProps> = ({ ArrayFields, handleInputChange }) => {
    const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);

    const handleFieldChange = (index: number, updatedField: Partial<ArrayItem>) => {
        const updatedArrayBody = ArrayFields.map((item, i) => (i === index ? { ...item, ...updatedField } : item));
        handleInputChange(updatedArrayBody);
    };

    const handleRowClick = (index: number) => {
        setSelectedRowIndex(index);
    };

    const handleAddRow = () => {
        const newRow: ArrayItem = { Property: '', DisplayText: '', Visible: false };
        handleInputChange([...ArrayFields, newRow]);
    };

    const handleDeleteRow = () => {
        if (selectedRowIndex !== null) {
            const updatedArrayBody = ArrayFields.filter((_, index) => index !== selectedRowIndex);
            handleInputChange(updatedArrayBody);
            setSelectedRowIndex(null);
        }
    };

    const renderHeaderTable = () => (
        <Row className="bg-primary text-white py-2 rounded">
            <Col xs={4} className="text-center">
                <label>Property</label>
            </Col>
            <Col xs={4} className="text-center">
                <label>Display Text</label>
            </Col>
            <Col xs={4} className="text-center">
                <label>Visible</label>
            </Col>
        </Row>
    );

    const renderFormFields = () => {
        return ArrayFields.map((field, index) => (
            <Row
                key={index}
                className={`mb-2 align-items-center row-fields ${selectedRowIndex === index ? 'selected-row' : 'unselected-row'}`}
                onClick={() => handleRowClick(index)}
            >
                <Col xs={4}>
                    <AvField
                        name={`Property_${index}`}
                        value={field.Property}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFieldChange(index, { Property: e.target.value })}
                        required
                    />
                </Col>
                <Col xs={4}>
                    <AvField
                        name={`DisplayText_${index}`}
                        value={field.DisplayText}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleFieldChange(index, { DisplayText: e.target.value })}
                        required
                    />
                </Col>
                <Col xs={4} className="text-center">
                    <Switch checked={field.Visible} onChange={(checked: boolean) => handleFieldChange(index, { Visible: checked })} />
                </Col>
            </Row>
        ));
    };

    return (
        <div className="container mt-4">
            <div className="button-group">
                <Button className="add-button-POD" onClick={handleAddRow}>
                    + Add
                </Button>
                <Button className="delete-button-POD" onClick={handleDeleteRow} disabled={selectedRowIndex === null}>
                    <i className="dripicons-trash fs-6"></i> Delete
                </Button>
            </div>
            {renderHeaderTable()}
            <AvForm className="mt-2">{renderFormFields()}</AvForm>
        </div>
    );
};

export default TableConfigFields;
